<template>
  <div>
    <div id="gContent">
      <div id="aTow">
        <div id="cNav">
          <router-link tag="span" :to="{path:'/Collection'}">馆藏</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<span>{{title}}</span>
        </div>
        <div id="lbimg"><img style="width: 100%;height: 100%;" src="../../assets/img/tout/guanc.jpg"></div>
        <div id="conList">
          <div id="wTable">
            <div id="tab1">文物名称</div>
            <div id="tab2">文物类别</div>
            <div id="tab3">文化类型</div>
          </div>
          <router-link id="oneCon" v-for="(item, index) in tableData" :key="index" tag="div" :to="{path:'/collectionDetials/collectionDetials', query:{collectionid:item.collectionid,title:title,textureid:textureid,t:encodeURIComponent(item.collectionname)}}">
            <div id="navdht"></div>
            <div>
              <div class="text" style="cursor: pointer;" :id="'ww'+index" @mouseenter="hideImg(index)" @mouseleave="showImg(index)">
                {{ item.collectionname }}
                <div v-show="seen&&current==index" style="width: 150px;height: 100px;position: absolute;left: 100%;z-index: 10;top: 10px;">
                  <img style="width: 100%;height: 100%;" :src="item.collectionimages">
                </div>
              </div>
              <div class="text">{{title}}</div>
              <div class="text">{{ item.category }}</div>
            </div>
          </router-link>
        </div>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10]" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal.total" style="margin: 3.125rem;text-align:right">
        </el-pagination>
      </div>
    </div>
    <div id="mgContent">
      <div id="maTow">
        <div id="mcNav">
          <router-link tag="span" :to="{path:'/Collection'}">馆藏</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<span>{{title}}</span>
        </div>
        <div id="mlbimg"><img style="width: 100%;height: 100%;" src="../../assets/img/tout/guanc.jpg"></div>
        <div id="mconList">
          <div id="mwTable">
            <div id="mtab1">文物名称</div>
            <div id="mtab3">文化类型</div>
          </div>
          <router-link id="moneCon" v-for="(item, index) in tableData" :key="index" tag="div" :to="{path:'/collectionDetials/collectionDetials', query:{collectionid:item.collectionid,title:title,textureid:textureid,t:encodeURIComponent(item.collectionname)}}">
            <div id="mnavdht"></div>
            <div>
              <div class="text" style="cursor: pointer;" :id="'ww'+index" @mouseenter="hideImg(index)" @mouseleave="showImg(index)">
                {{ item.collectionname }}
                <div v-show="seen&&current==index" style="width: 150px;height: 100px;position: absolute;left: 100%;z-index: 10;top: 10px;">
                  <img style="width: 100%;height: 100%;" :src="item.collectionimages">
                </div>
              </div>
              <div class="text">{{ item.category }}</div>
            </div>
          </router-link>
        </div>
        <el-pagination @size-change="mhandleSizeChange" @current-change="mhandleCurrentChange" :current-page="currentPage"
          :page-sizes="[10]" layout="total, prev, pager, next" :total="pageTotal.total" style="margin: 1.25rem;text-align:right">
        </el-pagination>
      </div>
    </div>
  </div>

</template>

<script>
  import {
    jquery
  } from '@/assets/js/jquery.js'
  import qs from 'qs'
  export default {
    data() {
      return {
        tableData: [],
        loading: false,
        picArr: [],
        conLength: 0,
        myNum: 0,
        seen: false,
        current: 0,
        pageTotal: [],
        currentPage: 1,
        pageSize: 10,
        pageNum: 1,
        title: "",
        textureid: 0
      }
    },
    watch: {
      '$route': function(to, from) {
        //执行数据更新查询
        this.title = this.$route.query.title;
        this.textureid = this.$route.query.id;
        this.search();
      }
    },
    mounted() {
      if (this.isMobile()) {
        document.getElementById("gContent").style.display = "none";
        document.getElementById("mgContent").style.display = "block"
        this.handleSearch();
      } else {
        document.getElementById("mgContent").style.display = "none";
        document.getElementById("gContent").style.display = "block"
        this.handleSearch();
      };
      this.title = this.$route.query.title;
      this.textureid = this.$route.query.id;
    },
    methods: {
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag;
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.search();
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.search();
      },
      mhandleSizeChange(val) {
        this.pageSize = val;
        this.search();
      },
      mhandleCurrentChange(val) {
        this.pageNum = val;
        this.search();
      },
      handleSearch() {
        this.search();
        let eWidth = document.body.clientWidth;
        document.getElementById("gContent").style.width = eWidth + "px";
        document.getElementById("lbimg").style.width = eWidth * 0.9 + "px";
        document.getElementById("lbimg").style.height = eWidth * 0.35 + "px";
        document.getElementById("aTow").style.marginLeft = (eWidth - eWidth * 0.9) / 2 + "px";
        document.getElementById("aTow").style.marginRight = (eWidth - eWidth * 0.9) / 2 + "px";
      },
      showImg: function(index) {
        this.seen = false;
        this.current = null;
      },
      hideImg: function(index) {
        this.seen = true;
        this.current = index;
      },
      // 查询列表
      search: function() {
        let that = this;
        this.loading = true;
        let url = this.HOST + '/api/v1/collection/getTextureAll?pageNumber=' + this.pageNum + '&pageSize=' + this.pageSize +
          '&texture=' + this.$route.query.id + ''
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.pageTotal = cData.data;
          that.currentPage = that.pageTotal.pageNum;
          that.tableData = cData.data.list;
          for (let i = 0; i < that.tableData.length; i++) {
            that.picArr.push(that.tableData[i]);
          };
          that.conLength = that.picArr.length;
        }).catch(function(error) {
          console.log(err);
        })
      }
    }
  }
</script>

<style scoped>
  #gContent {
    display: none;
  }

  #conList {
    margin-top: 25px;
  }

  #aTow>#cNav,
  #collCon>#cNav {
    text-align: left;
    line-height: 60px;
  }

  #aTow>#cNav>span:nth-child(1) {
    cursor: pointer;
  }

  #aTow>#cNav>span:nth-child(1):hover {
    color: #FF9900;
  }

  #wTable {
    height: 60px;
    position: relative;
    border-bottom: 1px solid #DEDEDE;
    background-color: #DEDEDE;
  }

  #tab1 {
    position: absolute;
    line-height: 30px;
    font-size: 1.3em;
    top: 15px;
    left: 5%;
    font-weight: 500;
  }

  #tab2 {
    position: absolute;
    line-height: 30px;
    font-size: 1.3em;
    top: 15px;
    left: 50%;
    font-weight: 500;
  }

  #tab3 {
    position: absolute;
    line-height: 30px;
    font-size: 1.3em;
    top: 15px;
    right: 5%;
    font-weight: 500;
  }

  #navdht {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 20px;
    left: 20px;
    cursor: pointer;
  }

  #navdht>img {
    width: 100%;
    height: 100%;
  }

  #oneCon {
    height: 60px;
    border-bottom: 1px solid #e5e5e5;
    position: relative;
    text-align: left;
  }

  #oneCon>div>div:nth-child(1) {
    position: absolute;
    line-height: 30px;
    font-size: 1em;
    top: 15px;
    left: 5%;
    padding: 0 20px 0 0;
  }

  #oneCon>div>div:nth-child(2) {
    position: absolute;
    line-height: 30px;
    font-size: 1em;
    top: 15px;
    left: 50%;
    cursor: pointer;
  }

  #oneCon>div>div:nth-child(3) {
    position: absolute;
    line-height: 30px;
    font-size: 1em;
    top: 15px;
    right: 5%;
    cursor: pointer;
  }

  #oneCon>div>.text {
    cursor: pointer;
  }

  #oneCon>div>.text:hover,
  #oneCon>div>div:nth-child(2):hover {
    color: #FF2222;
  }

  /*mobile*/
  #mconList {
    margin-top: 25px;
  }

  #maTow {
    margin: auto 20px;
  }

  #maTow>#mcNav,
  #mcollCon>#mcNav {
    text-align: left;
    line-height: 60px;
  }

  #maTow>#mcNav>span:nth-child(1) {
    cursor: pointer;
  }

  #maTow>#mcNav>span:nth-child(1):hover {
    color: #mFF9900;
  }

  #mwTable {
    height: 60px;
    position: relative;
    border-bottom: 1px solid #DEDEDE;
    background-color: #DEDEDE;
  }

  #mtab1 {
    position: absolute;
    line-height: 30px;
    font-size: 1.3em;
    top: 15px;
    left: 5%;
    font-weight: 500;
  }

  #mtab2 {
    position: absolute;
    line-height: 30px;
    font-size: 1.3em;
    top: 15px;
    left: 50%;
    font-weight: 500;
  }

  #mtab3 {
    position: absolute;
    line-height: 30px;
    font-size: 1.3em;
    top: 15px;
    right: 5%;
    font-weight: 500;
  }

  #mnavdht {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 20px;
    left: 20px;
    cursor: pointer;
  }

  #mnavdht>img {
    width: 100%;
    height: 100%;
  }

  #moneCon {
    height: 60px;
    border-bottom: 1px solid #e5e5e5;
    position: relative;
    text-align: left;
  }

  #moneCon>div>div:nth-child(1) {
    position: absolute;
    line-height: 30px;
    font-size: 1em;
    top: 15px;
    left: 5%;
    padding: 0 20px 0 0;
  }

  #moneCon>div>div:nth-child(2) {
    position: absolute;
    line-height: 30px;
    font-size: 1em;
    top: 15px;
    right: 5%;
    cursor: pointer;
  }

  #moneCon>div>.text {
    cursor: pointer;
  }

  #moneCon>div>.text:hover,
  #moneCon>div>div:nth-child(2):hover {
    color: #FF2222;
  }
</style>



// WEBPACK FOOTER //
// src/pages/collection/ceramics.vue